// extracted by mini-css-extract-plugin
module.exports = {"undoPageBody":"_8nnC5A","undoPageOptions":"_1TInIW","undoPageFooter":"aXUy47"};